import { __assign, __rest } from "tslib";
import React from 'react';
import { transformWireframeProps } from '../../utils/propUtils';
import VeltCommentDialogPriorityDropdownContentItemWireframe from './VeltCommentDialogPriorityDropdownContentItemWireframe/VeltCommentDialogPriorityDropdownContentItemWireframe';
;
var VeltCommentDialogPriorityDropdownContentWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comment-dialog-priority-dropdown-content-wireframe", __assign({}, transformedProps), children));
};
VeltCommentDialogPriorityDropdownContentWireframe.Item = VeltCommentDialogPriorityDropdownContentItemWireframe;
export default VeltCommentDialogPriorityDropdownContentWireframe;
